import { render, staticRenderFns } from "./gasOverview.vue?vue&type=template&id=3d6911bc&scoped=true&"
import script from "./gasOverview.vue?vue&type=script&lang=js&"
export * from "./gasOverview.vue?vue&type=script&lang=js&"
import style0 from "./gasOverview.vue?vue&type=style&index=0&id=3d6911bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6911bc",
  null
  
)

export default component.exports